import { useOrganizationContext } from 'hooks/contextOrganization';
import { useUserOrganizations } from 'hooks/userOrganizations';
import React, { useState } from 'react';
import { Popover } from 'UI';

import {
  MainContainer,
  DisplayOrgsButton,
  PopoverContentWrapper,
  ActionButton,
  ArrowIcon,
} from './style';

const OrganizationSelector = (): JSX.Element => {
  const userOrgs = useUserOrganizations();
  const organizationContext = useOrganizationContext();

  const [isVisible, setVisible] = useState(false);

  return (
    <MainContainer>
      <Popover
        placement="top"
        trigger="click"
        visible={isVisible}
        onVisibleChange={setVisible}
        title="Selecione outra unidade"
        content={(
          <PopoverContentWrapper>
            {userOrgs.map((org) => {
              const isCurrentOrg = org.id === organizationContext.organization?.id;
              return isCurrentOrg ? (
                <></>
              ) : (
                <ActionButton
                  key={org.id}
                  onClick={() => {
                    organizationContext.update(org);
                    setVisible(false);
                  }}
                >
                  {org.name}
                </ActionButton>
              );
            })}
          </PopoverContentWrapper>
        )}
      >
        <DisplayOrgsButton
          onClick={() => setVisible(!isVisible)}
        >
          {organizationContext.organization?.name}
          {isVisible ? (
            <ArrowIcon size={14} isActive />
          ) : (
            <ArrowIcon size={14} />
          )}
          {/* <DownOutlined size={14} /> */}
        </DisplayOrgsButton>
      </Popover>
    </MainContainer>
  );
};

export default OrganizationSelector;
